export default __webpack_public_path__ + "assets/laptop-6c0a9e5.svg";